module.exports = __webpack_public_path__ + "assets/9124cc96d40c24ff3493114d3af3233a.png";